import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * `text-caption` is a custom Tailwind v4 size (`--text-caption`, declared by
 * both apps' globals; `text-row` is the chat card's row size, declared in
 * packages/ui/src/palette.css). Stock `tailwind-merge` does not treat it as a
 * font-size, so `cn('text-sm', 'text-caption')` would keep both and
 * `text-sm` would win. Registering it on the `text` scale is what lets the
 * compact chrome overrides (`Button size="xs"`, `Badge`, `CommandItem`,
 * `SelectItem`) actually apply. Both apps share this implementation; do not fork it into either tree.
 *
 * The dialog kit's type steps (`text-dialog-*`, `tracking-dialog-kicker`,
 * app/dialog-theme.css) are registered the same way.
 *
 * The motion tokens (motion.css) get the same treatment: `duration-fast` and
 * `ease-smooth-out` are unknown to stock tailwind-merge, so a caller's
 * `duration-100` would not replace a primitive's `duration-fast`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        'caption',
        'row',
        'dialog-micro',
        'dialog-meta',
        'dialog-row',
        'dialog-lead',
        'dialog-title',
        'dialog-figure',
      ],
      tracking: ['dialog-kicker'],
      ease: ['smooth-out', 'bounce', 'bounce-strong'],
    },
    classGroups: {
      duration: [
        {
          duration: ['micro', 'quick', 'fast', 'medium', 'slow', 'very-slow'],
        },
      ],
    },
  },
})

export function cn(...inputs: Array<ClassValue>): string {
  return twMerge(clsx(inputs))
}
